<template>
	<div class="row offers mt-2">
		<b-col lg="12">
			<div class="card">
				<b-row align-h="center">
					<b-col lg="6">
						<div class="p-2">
							<div class="mt-2 text-center">Search Publisher</div>
							<b-input-group class="mt-3">
								<b-form-input
									v-model="query_search"
									type="search"
									placeholder="Type to search"
									@change="setQuerySearch"
									@keyup.enter="asyncFind"
									trim
								></b-form-input>
								<b-input-group-append>
									<b-button type="submit" variant="primary" @click="asyncFind">Search</b-button>
									<b-button type="button" variant="dark" class="ml-2" @click="asyncClearFind">Clear</b-button>
									<b-spinner v-show="isLoadingSearch" variant="dark" class="ml-2" label="Loading .."></b-spinner>
								</b-input-group-append>
							</b-input-group>
						</div>
					</b-col>
				</b-row>
				<div class="card-body">
					<b-row class="justify-content-end">
						<span class="pr-2">
							<router-link class="btn btn-sm btn-dark" :to="{name: PublisherCreatePath.name}">
                <em class="fa fa-plus"></em>
              </router-link>
						</span>
						<span>
							<button class="btn btn-sm btn-dark" @click="actionGetPublisher">
								<em class="fa fa-refresh"></em>
							</button>
						</span>
						<label for="" class="col-sm-auto">Count </label>
						<strong class="col-sm-auto">{{ totalRows }}</strong>
					</b-row>
					<b-table
						:items="items"
						:fields="fields"
						:busy="isLoading"
						:isLoading="isLoading"
						show-empty
						responsive
						class="mt-3"
						hover
					>
						<template v-slot:table-busy>
							<div class="text-center text-dark my-2">
								<b-spinner
									class="align-middle"
									variant="dark"
									type="grow"
									label="Loading .."
								>
								</b-spinner>
								Loading ..
							</div>
						</template>
						<template #cell(No)="row">
							{{ (currentPage - 1) * perPage + (row.index + 1) }}
						</template>
						<template #cell(username)="row">
							{{ row.item.username }}
						</template>
						<template #cell(email)="row">
							{{ row.item.email }}
						</template>
						<template #cell(full_name)="row">
							{{ row.item.full_name }}
						</template>
						<template #cell(option)="row">
							<router-link class="btn btn-sm btn-default" :to="{name: PublisherUpdatePath.name, params: {id: row.item.id}}">
								<em class="fa fa-edit"></em>
					</router-link><b-button
								variant="danger"
								@click="actionDeletePublisher(row.item.id)"
							><em class="fa fa-remove"></em> Delete</b-button>
						</template>
					</b-table>
				</div>
				<b-row v-if="(totalRows/perPage) > 1" class="justify-content-start ml-1">
					<b-col lg="3">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							aria-controls="my-table"
						/>
					</b-col>
				</b-row>
			</div>
		</b-col>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { PublisherCreatePath, PublisherUpdatePath } from "../../router/account";

export default {
	name: "access-publisher",
	data() {
		return {
			PublisherCreatePath,
			PublisherUpdatePath,
			currentPage: 1,
			perPage: 20,
			query_search: '',
			isLoadingSearch: false,
			fields: [
				{ key: "No", label: "No" },
				{
					key: "username",
					label: "Username",
				},
				{
					key: "email",
					label: "Email",
				},
				{
					key: "organization",
					label: "Organization",
				},
				{
					key: "vendor",
					label: "Vendor",
				},
				{ key: "option", label: "Option" },
			],
		};
	},
	computed: {
		...mapState({
			isLoading: (state) => state.accessPublisher.isLoading,
			items: (state) => state.accessPublisher.items,
			isError: (state) => state.accessPublisher.isError,
			totalRows: (state) => state.accessPublisher.totalRows,
		}),
	},
	mounted() {
		this.actionGetPublisher();
	},
	watch: {
		currentPage: function() {
			this.actionGetPublisher();
		},
	},
	methods: {
		...mapActions("accessPublisher", ["fetchPublisher", "searchPublisher", "deletePublisher"]),
		actionGetPublisher() {
			if (this.query_search == "") {
				let payload = {
					page: this.currentPage,
					limit: this.perPage,
				};
				this.fetchPublisher(payload);
			} else {
				this.asyncFind();
			}
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		setQuerySearch(query) {
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				this.query_search = query;
			}, 1000);
		},
		messageAlert(icon, title, timer = 3000) {
			this.$swal({
				toast: "true",
				position: "top-end",
				icon,
				title,
				showConfirmButton: false,
				timer,
				timerProgressBar: true,
			});
		},
		asyncFind() {
			this.isLoadingSearch = true;
			clearTimeout(this.debounce);
			this.debounce = setTimeout(() => {
				const query = this.query_search;
				if (!query) {
					this.actionGetPublisher();
					this.isLoadingSearch = false;
					return;
				}
				this.searchPublisher({
					q: query,
					page: this.currentPage,
					limit: this.perPage,
				})
					.then((response) => {
						this.items = response.data.data.rows;
						this.isLoadingSearch = false;
					})
					.catch(() => {
						this.isLoadingSearch = false;
					});
			}, 1000);
		},
		asyncClearFind() {
			this.query_search = "";
			this.actionGetPublisher();
			this.isLoadingSearch = false;
		},
		actionDeletePublisher(idUser) {
			this.$swal({
				title: "Are you sure?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Yes, delete it!",
			}).then((result) => {
				if (result.isConfirmed) {
					this.deletePublisher({ id: idUser })
					.then(() => {
						this.messageAlert("success", "Access has been deleted.");
						this.actionGetPublisher();
					})
					.catch((error) => {
						this.messageAlert("error", error.message);
					});
				}
			});
		},
	},
};
</script>
